import { organicMarketingChannels } from "@/constants/common";

import { getCookie } from "./cookies";

export const loadScript = (src: string) => {
  const scriptElement = document.createElement("script");
  scriptElement.src = src;
  scriptElement.defer = true;
  document.body.appendChild(scriptElement);
};

let timer: NodeJS.Timeout;
export const debounce = (fn: () => void, delay = 300) => {
  return (() => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(), delay);
  })();
};

const PAGES: Record<string, string[]> = {
  "Job Details": ["/job"],
  Home: ["/", "/user"],
};

const PAGE_NAME_MAPPING: Record<string, string> = {};
for (const [pageName, paths] of Object.entries(PAGES)) {
  paths.forEach((path) => {
    PAGE_NAME_MAPPING[path] = pageName;
  });
}

export const getPageName = (url: string | null) => {
  const pathName = "/" + (url?.split("/")[1] || "");
  return PAGE_NAME_MAPPING[pathName] || "Home";
};

export const clearHTMLTags = (strToSanitize: string) => {
  return strToSanitize.replace(/(<([^>]+)>)/gi, "");
};

let internalNetworkCode: string | number = "";
export const networkCode = {
  get: () => internalNetworkCode,
  set: (nc: string | number) => (internalNetworkCode = nc),
};

export const getOS = () => {
  let OSName = "Unknown";
  if (navigator.userAgent.indexOf("Windows") != -1) OSName = "Windows";
  if (navigator.userAgent.indexOf("Mac OS") != -1) OSName = "MacOS";
  if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
  if (navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";

  return OSName;
};

export const getMarketingChannel = (spl: string) => {
  if (spl) return "Paid";
  else {
    let ref = getCookie("ref");
    if (ref) {
      for (const organic of organicMarketingChannels) {
        if (ref.toUpperCase().includes(organic?.toUpperCase()))
          return "Organic";
      }

      if (ref.toUpperCase().includes("FOUNDIT")) return "Direct";
      else return "Other";
    } else return "Direct";
  }
};
export const getProfileExperience = (years: number, months: number): string => {
  return `${years + (months >= 5 ? 1 : 0)} years`;
};
